import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getValidSession, clearSession } from "../helpers/sessionUtils";
import useFrontendNavigationPages from "../../components/common/useFrontendNavigationPages";

function Header() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigationPages = useFrontendNavigationPages();

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // const logoUrl = "https://www.itarsia.com/img/logo.png";
  const logoUrl = "/logo-mangoloops.png";
  const myAccountIconUrl = "/assets/img/my-account.png";
  const dashboardIconUrl = "/assets/img/sidebar/dashboard.png";
  const leadsIconUrl = "/assets/img/sidebar/leads.png";
  const privacyPolicyIconUrl = "/assets/img/sidebar/privacy-policy.png";
  const feedbackIconUrl = "/assets/img/sidebar/feedback.png";
  const helpIconUrl = "/assets/img/sidebar/help.png";
  const logoutIconUrl = "/assets/img/sidebar/logout.png";

  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const syncFromStorage = () => {
      // Prefer the app session (userSessionData), but always fall back to localStorage keys
      // so logged-in icon renders on every detail page.
      const userSession = getValidSession();

      let resolvedUser = null;
      if (userSession?.user) {
        // expected shapes across the app:
        // - { user: { user: {..}, token: .. } }
        // - { user: { .. } }
        resolvedUser = userSession.user?.user || userSession.user || null;
      }

      if (!resolvedUser) {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const parsed = JSON.parse(userInfoStr);
            resolvedUser = parsed?.user?.user || parsed?.user || parsed || null;
          } catch {
            resolvedUser = null;
          }
        }
      }

      if (!resolvedUser) {
        const visitorUserStr = localStorage.getItem('visitorUser');
        if (visitorUserStr) {
          try {
            const parsed = JSON.parse(visitorUserStr);
            resolvedUser = parsed?.user?.user || parsed?.user || parsed || null;
          } catch {
            resolvedUser = null;
          }
        }
      }

      setCurrentUser(resolvedUser);

      // Ensure token keys exist (some pages rely on these)
      if (resolvedUser?.token && !localStorage.getItem('authToken')) {
        localStorage.setItem('authToken', resolvedUser.token);
      }
      if (resolvedUser?.token && !localStorage.getItem('token')) {
        localStorage.setItem('token', resolvedUser.token);
      }
    };

    syncFromStorage();

    const handleStorageChange = () => {
      syncFromStorage();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  const handleLogout = () => {
    clearSession();
    localStorage.removeItem('userInfo');
    localStorage.removeItem('visitorUser');
    setCurrentUser(null);
    setIsSidebarOpen(false);
    navigate("/");
  };

  const showVendorSpecificOptions =
    currentUser && currentUser.isVendor && currentUser.isVisitor;
  const displayName = currentUser ? currentUser.name : "User Name";
  const userRole = currentUser ? currentUser.role_id : "user Id";

  return (
    <div>
      <header
        id="header"
        className="u-header u-header--dark-nav-links-xl u-header--show-hide-xl u-header--static-xl"
        data-header-fix-moment="500"
        data-header-fix-effect="slide"
      >
        <div className="u-header__section u-header__shadow-on-show-hide py-4 py-xl-0">
          <div
            id="logoAndNav"
            className="container-fluid py-xl-2 border-bottom-xl"
          >
            <nav className="js-mega-menu navbar navbar-expand-xl u-header__navbar u-header__navbar--no-space">
              <button
                type="button"
                className="navbar-toggler btn u-hamburger u-hamburger--primary pt-4 hamburger-pl-0 ml-3"
                aria-label="Toggle navigation"
                aria-expanded={isMobileNavOpen}
                aria-controls="navBar"
                onClick={toggleMobileNav}
              >
                <span id="hamburgerTrigger" className="u-hamburger__box">
                  <span className="u-hamburger__inner"></span>
                </span>
              </button>

              <Link
                to="/"
                className="navbar-brand u-header__navbar-brand-default u-header__navbar-brand-center u-header__navbar-brand-text-dark-xl"
                aria-label="MyTour"
              >
                <img
                  className="navbar-brand-img"
                  src={logoUrl}
                  alt="Mangoloops Logo"
                />
              </Link>

              <button
                type="button"
                className="p-0 ml-auto third my-account-btn"
                onClick={() => {
                  if (currentUser) {
                    toggleSidebar();
                  } else {
                    navigate("/login");
                  }
                }}
                aria-label="Toggle user menu"
                style={{ width: "auto", border: "none", background: "transparent", order: 3 }}
              >
                <div className="d-flex align-items-center" style={{ gap: '6px', margin: '0 10px', cursor: 'pointer' }}>
                  {currentUser && currentUser.profileImageUrl ? (
                    <img
                      src={currentUser.profileImageUrl}
                      alt="my-account"
                      style={{ width: "28px", height: "28px", borderRadius: "50%", objectFit: "cover" }}
                    />
                  ) : (
                    <>
                      <i className="flaticon-user" style={{ fontSize: '20px', color: '#205aa3' }}></i>
                      {!currentUser && (
                        <span className="d-inline-block" style={{ fontWeight: '600', color: '#205aa3', fontSize: '13px', whiteSpace: 'nowrap' }}>Signup</span>
                      )}
                    </>
                  )}
                </div>
              </button>

              {/* Sidebar START */}
              <div className={`side-bar ${isSidebarOpen ? "active" : ""}`}>
                <header>
                  <div
                    className="close-btn"
                    onClick={toggleSidebar}
                    role="button"
                    tabIndex="0"
                    aria-label="Close user menu"
                  >
                    <i className="fas fa-times"></i>
                  </div>
                </header>

                {/* Profile Header Section */}
                {currentUser && (
                  <div
                    className="profile-header"
                    style={{ cursor: "pointer", display: 'flex', alignItems: 'center' }}
                    onClick={() => {
                      if (userRole === 2) {
                        setIsSidebarOpen(false);
                        navigate("/admin/kyc", { state: { user: currentUser } });
                      }
                    }}
                  >
                    <div>
                      {currentUser.profileImageUrl ? (
                        <img
                          className="sidebar-profile-img profile-img"
                          src={currentUser.profileImageUrl}
                          alt="Profile Picture"
                        />
                      ) : (
                        <i className="far fa-user-circle" style={{ fontSize: '48px', color: '#128abe' }}></i>
                      )}
                    </div>
                    <div style={{ marginLeft: '14px' }}>
                      <h4 className="profile-header-h4" style={{ margin: 0 }}>{displayName}</h4>
                      {userRole === 2 ? (
                        <Link
                          to="/admin/kyc"
                          state={{ user: currentUser }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsSidebarOpen(false);
                          }}
                          className="view-profile"
                          style={{ display: 'block', marginTop: '4px' }}
                        >
                          Click to view profile
                        </Link>
                      ) : ""}
                    </div>
                  </div>
                )}

                {/* Menu Items */}
                {/* Apply border only if vendor options are shown */}
                <div className={`menu ${showVendorSpecificOptions ? "border-bottom-sidebar" : ""}`}>
                  {/* Conditional "My Business" and "Leads" - only if logged in & vendor */}
                  {userRole === 2 && (
                    <>
                      <div className="item">
                        <Link
                          to="/admin/dashboard"
                          state={{ user: currentUser }}
                          onClick={() => setIsSidebarOpen(false)}
                          className="d-flex align-items-center"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={dashboardIconUrl} alt="My Business" style={{ marginRight: '12px', width: '20px', height: '20px' }} />
                          <span style={{ fontWeight: '500' }}>My Business</span>
                        </Link>
                      </div>
                    </>
                  )}

                  {/* Common menu items for ALL users (logged in or not) */}
                  <div className="item">
                    <Link to="/privacy-policy" onClick={() => setIsSidebarOpen(false)}>
                      <img src={privacyPolicyIconUrl} alt="Privacy Policy" />
                      Privacy Policy
                    </Link>
                  </div>
                  <div className="item">
                    <Link to="/feedback" onClick={() => setIsSidebarOpen(false)}>
                      <img src={feedbackIconUrl} alt="feedback" />
                      Feedback
                    </Link>
                  </div>
                  <div className="item">
                    <Link to="/help" onClick={() => setIsSidebarOpen(false)}>
                      <img src={helpIconUrl} alt="Help" />
                      Help
                    </Link>
                  </div>

                  {/* Logout item - only if logged in */}
                  {currentUser && (
                    <div className="item">
                      <Link onClick={handleLogout} style={{ cursor: "pointer" }}>
                        <img src={logoutIconUrl} alt="Logout" />
                        Logout
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              {/* Sidebar END */}

              {isSidebarOpen && (
                <div
                  className="sidebar-overlay active"
                  onClick={toggleSidebar}
                ></div>
              )}

              <div
                id="navBar"
                className={`navbar-collapse u-header__navbar-collapse collapse order-xl-0 pt-4 p-xl-0 position-relative ${isMobileNavOpen ? "show" : ""
                  }`}
              >
                <ul className="navbar-nav u-header__navbar-nav">
                  {navigationPages.map((page) => (
                    <li className={`nav-item u-header__nav-item ${page.page_key === 'hotels' ? 'hotels mainMenu' : ''}`} key={page.page_key}>
                      <Link
                        to={page.slug}
                        className="menu-sec nav-link"
                        onClick={() => setIsMobileNavOpen(false)}
                      >
                        <span className={`meuicowidth ${page.iconClass}`}></span>
                        <span className="menu-title-span">{page.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>
      <style>{`
        #navBar .menu-sec .meuicowidth,
        #navBar .menu-sec:hover .meuicowidth,
        #navBar .menu-sec:focus .meuicowidth,
        #navBar .menu-sec:focus-visible .meuicowidth,
        #navBar .menu-sec:active .meuicowidth,
        #navBar .menu-sec:visited .meuicowidth {
          width: 35px !important;
          min-width: 35px !important;
          max-width: 35px !important;
          height: 35px !important;
          min-height: 35px !important;
          max-height: 35px !important;
          flex: 0 0 35px !important;
          background-size: 355px 330px !important;
          transform: none !important;
          transition: none !important;
          animation: none !important;
        }

        #navBar .menu-sec *,
        #navBar .menu-sec:hover *,
        #navBar .menu-sec:focus *,
        #navBar .menu-sec:active * {
          transform: none !important;
          transition: none !important;
          animation: none !important;
        }

        #navBar .u-header__navbar-nav {
          gap: 4px !important;
        }

        @media (max-width: 1199px) {
          #navBar {
            flex: 0 0 100% !important;
            width: 100% !important;
            padding-top: 24px !important;
          }

          #navBar .u-header__navbar-nav,
          #navBar .navbar-nav {
            align-items: center !important;
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            gap: 6px !important;
            justify-content: center !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
            overflow-x: visible !important;
            overflow-y: hidden !important;
            padding: 0 8px 18px !important;
            white-space: normal !important;
            width: 100% !important;
          }

          #navBar .u-header__nav-item,
          #navBar .nav-item {
            flex: 1 1 0 !important;
            margin: 0 !important;
            min-width: 0 !important;
            width: auto !important;
          }

          #navBar .menu-sec {
            background: #fff !important;
            border: 1px solid #ebeaea !important;
            border-radius: 5px !important;
            box-shadow: none !important;
            gap: 2px !important;
            height: 76px !important;
            justify-content: center !important;
            margin: 0 !important;
            min-width: 0 !important;
            padding: 6px 4px !important;
            width: 100% !important;
          }

          #navBar .menu-title-span {
            color: #000 !important;
            font-size: 11px !important;
            font-weight: 600 !important;
            line-height: 1.2 !important;
            padding-top: 0 !important;
            white-space: normal !important;
            word-break: normal !important;
          }
        }

        @media (min-width: 576px) and (max-width: 1199px) {
          #navBar .u-header__navbar-nav,
          #navBar .navbar-nav {
            gap: 12px !important;
            padding-left: 24px !important;
            padding-right: 24px !important;
          }

          #navBar .menu-sec {
            max-width: 150px !important;
            padding-left: 10px !important;
            padding-right: 10px !important;
          }

          #navBar .menu-title-span {
            font-size: 13px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Header;
